<template>
  <div>
    <template v-if="is_sidebar">
    <v-navigation-drawer app fixed style="margin-left: 80px; top: 64px;" :dark="$dark()" width="350" :mini-variant.sync="mini" v-model="drawer" v-if="!$compact_view()">
<!--
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-tile avatar tag="div">
            <v-list-tile-avatar>
              <v-icon>account_circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{current_name || current_email}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon @click.native.stop="drawer = !drawer">
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>-->

<!--      <v-divider></v-divider>-->
     <router-view name="sidebar"></router-view>

    </v-navigation-drawer>
    </template>



<!--    <div v-model="mainmenu" app fixed persistent overflow disable-resize-watcher disable-route-watcher width="80" style="top: 64px; padding-top: 10px; background-color: rgb(33,33,33);" >-->
    <div style="background-color: rgb(33,33,33); z-index: 100; position: fixed; top: 64px; bottom: 0px; padding-top: 10px; width: 80px; overflow-y: auto; overflow-x: hidden;" class="hide-scrollbar" v-if="!$compact_view()">

      <v-btn v-for="item in filtered_items" :key="item.title" :to="item.url" plain tile block active-class="menu-active" depressed color="transparent" text-color="deep-orange" class="ma-0 pl-3" style="height: 50px; width: 80px; text-align: center; min-width: 80px; max-width: 80px;">
        <div style="display: grid; grid-template-rows: 1fr 1fr; font-size: 10px; width: 100%; text-transform: none;">
            <v-icon style="text-align: center; font-size: 20px;">{{item.icon}}</v-icon>
            <div style="white-space: nowrap; overflow: auto;">{{item.title}}</div>
        </div>
      </v-btn>
      <v-divider></v-divider>


      <v-btn plain tile active-class="menu-active" depressed color="transparent" text-color="deep-orange" class="ma-0 pl-3" style="height: 50px; width: 80px; max-width: 80px; min-width: 80px; text-align: center;" @click="logout">
        <div style="display: grid; grid-template-rows: 1fr 1fr; font-size: 10px; width: 100%; text-transform: none;">
            <v-icon style="text-align: center; font-size: 20px;">power_settings_new</v-icon>
            <div style="white-space: nowrap; overflow: auto;">Logout</div>
        </div>
      </v-btn>
      <v-divider></v-divider>

    </div>



    <v-toolbar fixed :class="$dark() ? 'grey darken-4' : 'deep-orange'" dark  v-if="!$compact_view()">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" :disabled="!is_sidebar"></v-toolbar-side-icon>
      <v-toolbar-title><img src="../assets/kepit_logo_full.png" style="height: 55px; padding-top: 10px;"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title right>
        <router-view name="topbar"></router-view>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <v-tooltip bottom color="info" v-if="maintenance.running">
          <template v-slot:activator="{ on }">
            <v-chip color="info" text-color="white" style="border-radius: 5px;" v-on="on">
              <v-avatar>
                <v-icon>info</v-icon>
              </v-avatar>
              System maintenance begins on {{maintenance_start_timestamp | format_date}} at {{maintenance_start_timestamp | format_time}}.
            </v-chip>
          </template>
          <span>
            <b>Estimated time to complete</b>
            <br>
            {{maintenance_end_timestamp | format_date}} {{maintenance_end_timestamp | format_time}}
            <br>
            <b>Message</b>
            <br>
            <span v-html="message"></span>
          </span>
        </v-tooltip>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title style="font-size: 16px;" right v-if="$is_admin() || $account_type() == 'user'" class="hidden-xs-only">{{timestamp | format_date}} - {{timestamp | format_time_seconds}} {{timestamp | format_time_timezone}}</v-toolbar-title>

      <v-toolbar-title class="hidden-xs-only">
        <v-icon>account_circle</v-icon>
      </v-toolbar-title>
      <v-toolbar-title class="hidden-xs-only">
        <span>{{current_name || current_email}}</span>
      </v-toolbar-title>

    </v-toolbar>

    <v-toolbar :class="$dark() ? 'grey darken-4' : 'deep-orange'" dark app dense v-if="$compact_view() && !$popup_view()">
      <v-toolbar-title>{{current_name || current_email}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat @click="logout">Logout</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-content :class="[{'processbar-extended': processbar, 'menu-margin': !drawer || !is_sidebar, 'compact-margin': $compact_view()}]" style="margin-top: 63px; margin-left: 80px;">
      <v-container fluid>
        <Loading :visible="loading || loadingEventInfos || maintenance_running" :error="alert || alertEventInfos">
          <div v-show="!alert && !loading && !alertEventInfos && !loadingEventInfos && !maintenance_running">
            <router-view></router-view>
          </div>
          <div slot="infoContent">
            <v-alert color="error" v-model="alert">
              Sorry, Something went wrong! <v-btn @click="reload" icon class="white--text"><v-icon>cached</v-icon></v-btn>
            </v-alert>
          </div>
        </Loading>
      </v-container>
    </v-content>
    <processbar v-model="processbar" v-if="!$compact_view()"></processbar>
  </div>
</template>

<script>
import Processbar from './Processbar'
import Loading from "./Loading"
import datelib from '../lib/date.js';
import moment from 'moment';
import SettingsModel from '@/models/settings.js';
export default {
  components: {
    Processbar,
    Loading
  },
  filters: datelib,

  data () {
    return {
      loading: false,
      alert: false,
      loadingEventInfos: false,
      alertEventInfos: false,
      counter: 0,
      drawer: true,
      mini: false,
      processbar: false,
      items: [
        {title: "Dashboard", icon: "dashboard", url: "/dashboard", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Productions", icon: "inventory", url: "/productions", router: true, access: ["admin", "device_admin", "developer"], group_meta: ["productions"]},
        {title: "Events", icon: 'event', url: "/events", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Clips", icon: 'event', url: "/cloudrec", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user", "cloudrec"]},
        {title: "Content", icon: 'view_list', url: "/content", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Channels", icon: 'movie', url: "/channels", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Instances", icon: 'settings_ethernet', url: "/instances", router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "Devices", icon: 'computer', url: '/devices', router: true, access: ["device_admin", "root", "developer"]},
        {title: "Billing", icon: 'savings', url: '/billing', router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "Monitor", icon: 'ondemand_video', url: "/monitor", router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "System Monitor", icon: 'ondemand_video', url: "/sysmonitor", router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "Multiview", icon: 'view_module', url: "/multiview", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Settings", icon: "settings", url: "/settings", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Developer", icon: "settings", url: "/developer", router: true, access: ["developer"]},

      ]
    }
  },

  watch: {
    loading (newVal) {
      if(!newVal && !this.loadingEventInfos && !this.$root.loaded) this.$root.loaded = true;
    },
    loadingEventInfos (newVal) {
      if(!this.loading && !newVal && !this.$root.loaded) this.$root.loaded = true;
    }
  },
  computed: {
    is_sidebar () {
      var ret = false;
      _.each(this.$route.matched, function(route) {
        if (_.includes(Object.keys(route.components), "sidebar")) {
          ret = true;
        }
      });
      return ret;
    },
    timestamp () {
      return this.$store.state.timestamp;
    },
    filtered_items () {
      var is_admin = this.$is_admin();
      var account_type = this.$store.getters.account_type;
      var groups = this.$store.getters.groups;
      return _.filter(this.items, function(item) {
        if (typeof(item.access) == "undefined" && typeof(item.group_meta) == "undefined") return true;
        if (item.access.includes(account_type)) return true;
        if (typeof(item.group_meta) != "undefined") {
          var group = _.find(groups, function(g) {
            if (g.meta[item.group_meta] == true) return true;
          });
          if (typeof(group) != "undefined") return true;
        }
        return false;
      });
    },
    account_type () {
      return this.$store.getters.account_type;
    },
    current_email () {
      return (this.$store.state.account||{}).email;
    },
    current_name () {
      if(typeof(this.$store.state.account) == "undefined") return undefined;
      if(!this.$store.state.account.name || !this.$store.state.account.surname) return undefined;
      return this.$store.state.account.name + " " + this.$store.state.account.surname;
    },
    maintenance() {
      return this.$store.state.maintenance;
    },
    maintenance_start_timestamp() {
      return _.get(this.maintenance, "info.start_time");
    },
    maintenance_end_timestamp() {
      return _.get(this.maintenance, "info.end_time");
    },
    maintenance_message() {
      return _.get(this.maintenance, "info.message");
    },
    maintenance_running() {
      var account = (this.$store.state.account||{})
      var setting = SettingsModel.get_by_name("maintenance") || {value: {bypass_accounts: []}};
      return this.maintenance.running && this.maintenance.info.start_time <= (this.timestamp || moment().unix()) && setting.value.bypass_accounts.indexOf(account.id) == -1;
    }
  },
  methods: {
    logout () {
      if(!confirm("Do you really want to log out?")) return;

      this.$store.dispatch("log_out").then(() => {
        this.$router.push({
          path: "/login",
          query: {l: 1}
        })
      },
      (error) => {
        console.log(error.response);
        alert(error.msg);
      });
    },
    reload () {
      location.reload();
    }
  },
  mounted () {
  },
  socket: {
    open () {
      this.loading = false;
      this.alert = false;
      this.counter = 0;
    },
    close (msg) {
      this.loading = true;
      if(this.counter > 3) {
        this.alert = true;
      } else {
        this.counter = this.counter + 1;
      }
    }
  }
}
</script>
<style>
.v-content {
  padding-bottom: 53px !important;
}
.v-content.processbar-extended {
  padding-bottom: 200px !important;
}
.content {
  padding-top: 60px;
}
</style>

<style scoped>
.hide-scrollbar {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.hide-scrollbar::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
}
.compact-margin {
  margin-left: 0px !important;
  padding-top: 0px !important;

}

.menu-margin {
  margin-left: 80px;
}
.menu-active {
  color: rgb(248,216,74) !important;
}
.logo {
  background-color: #324157;
  height: 60px;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}
.logo img {
  max-width: 100%;
  max-height: 80%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>
